<template>
    <div class="sub-page">
        <div class="main_section">
            <div class="section_item culture-block">
                <h2 class="title">{{cultureTitle}}</h2>
                <div class="center culture-img">
                    <img v-for="(image, index) in cultureImg" :key="index" :src="image" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';
import router from '@/router';

export default {
    name: 'corpCulture',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            cultureTitle: '',
            cultureImg: [],
        };
    },
    mounted() {
        ajax.get('/web/about_us/company_culture.json', {}).then((result) => {
            this.cultureImg = this.isCn ? result.data.cnWebImages : result.data.enWebImages;
            this.cultureImg = this.cultureImg ? this.cultureImg.split(',') : [];
            this.cultureTitle = this.isCn ? result.data.cnName : result.data.enName;
        }).catch(() => {});
    },
    methods: {
        goBack() {
            router.go(-1);
        },
    },
};
</script>
<style lang="less" scoped>
    .main_section{
        border-top: 8px solid #F8FAF9;
        width: 100%;
        height: auto;
        .section_item{
            width: 100%;
            height: auto;
            &:nth-child(even){
                background:rgba(248,250,249,1);
            }
            .title{
                padding-top: 40px;
                font-size: 20px;
                font-weight: 600;
                color: rgba(74,74,74,1);
                line-height: 20px;
                text-align: center;
                position: relative;
                &::after{
                    content:"";
                    width:44px;
                    height:4px;
                    background:rgba(199,31,75,1);
                    position: absolute;
                    bottom: -12px;
                    left: 50%;
                    margin-left: -22px;
                }
            }
        }
    }
    .center {
        width: 960px;
        margin: 20px auto;
    }
    .culture-img {
        img {
            display: block;
            margin: 10px 0;
            width: 100%;
        }
    }
</style>
